import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const IbanBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        iban: z.string().regex(/^[a-zA-Z]{2}[a-zA-Z0-9\\s]{2,32}$/, {
            message: 'IBAN should contain 4 to 34 letters or digits and start with 2 letters',
        }),
    }),
).strict();

export class IbanBankAccountPayload extends BankAccountPayload {
    iban: string;
}
